/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_App_DescriptionInputs */

const en_admin_settings_fields_app_description = /** @type {(inputs: Admin_Settings_Fields_App_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Description`)
};

/**
* | output |
* | --- |
* | "App Description" |
*
* @param {Admin_Settings_Fields_App_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_app_description = /** @type {((inputs?: Admin_Settings_Fields_App_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_App_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_app_description(inputs)
});
export { admin_settings_fields_app_description as "admin.settings.fields.app_description" }